"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SupportGroupIntroStaticLayout", {
  enumerable: true,
  get: function get() {
    return _SupportGroupStaticLayout.default;
  }
});
Object.defineProperty(exports, "WelcomeStaticLayout", {
  enumerable: true,
  get: function get() {
    return _WelcomeStaticLayout.default;
  }
});
var _SupportGroupStaticLayout = _interopRequireDefault(require("./SupportGroupStaticLayout"));
var _WelcomeStaticLayout = _interopRequireDefault(require("./WelcomeStaticLayout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }